import {Mixin, mix} from "mixwith";
import MutableMixin from "./MutableMixin.js";
import {deepCopy} from "../../Utils/ObjectUtils.js";

export const MutableValueMixin = Mixin(superClass => class extends mix(superClass).with(MutableMixin) {

	static get properties() {
		return {
			value: {
				type: String
			}
		};
	}

	/**
	 * Sets the items to the defaultItems.
	 *
	 * @override
	 */
	resetChanges() {
		this.value = deepCopy(this.defaultValue);
	}

	/**
	 * Sets the current items as defaultItems.
	 *
	 * @override
	 */
	saveChanges(newValue = undefined) {
		if(newValue !== undefined)
			this.value = newValue;
		this.defaultValue = deepCopy(this.value);
		this.setInitialValue(this.defaultValue);
		this.updateChanges(this.defaultValue);
	}

	firstUpdatedBeforeRender() {
		super.firstUpdatedBeforeRender();

		if(!this.hasInitialValue()) {
			// Sets the initial value as defaultValue which will be used when the element resets.
			if(this.defaultValue === undefined)
				this.defaultValue = deepCopy(this.value);

			// Sets the initial value.
			this.setInitialValue(this.defaultValue);
		}
	}

	update(changedProperties) {
		if(changedProperties.size === 0 || changedProperties.has("value")) {
			// Update Mutation.
			{
				this.updateChanges(this.value);

				// Update binding
				const event = new CustomEvent("change", {
					composed: true,
					detail: {
						value: deepCopy(this.value)
					}
				});

				this.dispatchEvent(event);
			}
		}

		super.update(changedProperties);
	}

});

export default MutableValueMixin;